import type { v2 } from '@deque/billing-service-client';
import React from 'react';
import { getAiCreditBalance } from '~/common/api-client';
import useAPI, { type State } from '~/common/hooks/useAPI';

const useAICreditBalance = (token: string): State<v2.MetricWithLimits> => {
  const dataLoader = React.useCallback(
    () => getAiCreditBalance(token),
    [token]
  );
  return useAPI(dataLoader);
};

export default useAICreditBalance;
